module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('PageTitle', {
    attrs: {
      "pagetitle": "优化建议操作列表",
      "tip": "我们将每日为您采纳的建议创建一个优化模板，您可以将优化模板一键同步至点睛生效，同步前您也可以在模板上调整优化内容",
      "showTime": false
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dianjingIDList.length > 0),
      expression: "dianjingIDList.length > 0"
    }],
    staticClass: "indices-menu pull-right"
  }, [_c('span', {
    staticClass: "font-grey"
  }, [_vm._v("账号切换：")]), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dianjingID),
      expression: "dianjingID"
    }],
    attrs: {
      "options": _vm.dianjingIDList
    },
    domProps: {
      "value": (_vm.dianjingID)
    },
    on: {
      "input": function($event) {
        _vm.dianjingID = $event
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "zone opt-zone mt-5"
  }, [_c('table', {
    staticClass: "opt-table",
    attrs: {
      "id": 'opt-service-table'
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.totalColumns.listColumns), function(column) {
    return _c('th', [_vm._v(_vm._s(column))])
  }))]), _c('tbody', [_vm._l((_vm.tableList), function(item, index) {
    return [_c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isListLoading && _vm.tableList.length),
        expression: "!isListLoading && tableList.length"
      }]
    }, [_c('td', [_vm._v(_vm._s(item.template_name))]), _c('td', [_vm._v(_vm._s(item.createtime))]), (item.effecttime.slice(0, 4) !== '0000') ? _c('td', [_vm._v(_vm._s(item.effecttime))]) : _c('td', [_vm._v("----")]), (item.status === 0) ? _c('td', [_c('i', {
      staticClass: "i-ellipsis"
    }), _c('span', {
      staticClass: "status-txt status0"
    }, [_vm._v(_vm._s('待应用'))])]) : _vm._e(), (item.status === 1) ? _c('td', [_c('i', {
      staticClass: "i-check-square"
    }), _c('span', {
      staticClass: "status-txt status1"
    }, [_vm._v(_vm._s('已应用 ')), _c('small', [_vm._v(_vm._s('（全部生效）'))])])]) : _vm._e(), (item.status === 2) ? _c('td', [_c('i', {
      staticClass: "i-check-square"
    }), _c('span', {
      staticClass: "status-txt status1"
    }, [_vm._v(_vm._s('已应用 ')), _c('small', [_vm._v(_vm._s('（部分生效）'))])])]) : _vm._e(), (item.status === 3) ? _c('td', [_c('i', {
      staticClass: "i-minus-circle"
    }), _c('span', {
      staticClass: "status-txt status2"
    }, [_vm._v(_vm._s('已过期'))])]) : _vm._e(), (item.status === 4) ? _c('td', [_c('i', {
      staticClass: "i-download"
    }), _c('span', {
      staticClass: "status-txt status2"
    }, [_vm._v(_vm._s('已下载'))])]) : _vm._e(), _c('td', {
      staticClass: "operate-cell"
    }, [(item.status === 0) ? _c('i', {
      staticClass: "mr-20 pointer",
      attrs: {
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewOpt($event, item, true)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), (item.createtime.slice(0, 10) === _vm.today && item.status === 2) ? _c('i', {
      staticClass: "mr-20 pointer",
      attrs: {
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewOpt($event, item, true)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), (item.createtime.slice(0, 10) !== _vm.today && item.status === 2) ? _c('i', {
      staticClass: "mr-20 pointer",
      attrs: {
        "title": "查看"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewOpt($event, item, false)
        }
      }
    }, [_vm._v("查看")]) : _vm._e(), (item.status === 1 || item.status === 3 || item.status === 4) ? _c('i', {
      staticClass: "mr-20 pointer",
      attrs: {
        "title": "查看"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewOpt($event, item, false)
        }
      }
    }, [_vm._v(" 查看")]) : _vm._e(), _c('i', {
      staticClass: "mr-20 pointer",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.deleteItem($event, item)
        }
      }
    }, [_vm._v("删除")]), (item.status === 1 || item.status === 2) ? _c('i', {
      staticClass: "mr-20 pointer",
      on: {
        "click": function($event) {
          _vm.showEffect($event, item)
        }
      }
    }, [_vm._v("效果对比")]) : _c('i', {
      staticClass: "mr-20 pointer"
    }, [_vm._v("----")])])])]
  }), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isListLoading && _vm.tableList.length === 0),
      expression: "!isListLoading && tableList.length === 0"
    }]
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("您还未创建任何操作模板，请先返回"), _c('i', {
    staticClass: "link-opt"
  }, [_c('router-link', {
    attrs: {
      "to": '/web/optimizeaccount'
    }
  }, [_vm._v("账户优化")])], 1), _vm._v("采纳优化建议")])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isListLoading),
      expression: "isListLoading"
    }]
  }, [_vm._m(0)])], 2)]), _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pageNum,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.getOperateList
    }
  })], 1), _c('v-modal', {
    attrs: {
      "id": 'opt-modal',
      "visible": _vm.modalSettingVisible,
      "title": _vm.modalTitle,
      "sub-title": _vm.modalSubTitle,
      "safe": _vm.modalSafe
    },
    on: {
      "closemodal": _vm.modalInfoReset
    }
  }, [(_vm.modalFormat === 'linechart') ? _c('div', {
    staticClass: "modal-bd-wrapper opt-zone"
  }, [_c('div', {
    staticClass: "floatr"
  }, [_c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indiceSelected),
      expression: "indiceSelected"
    }],
    attrs: {
      "name": "indice",
      "options": _vm.indiceList
    },
    domProps: {
      "value": (_vm.indiceSelected)
    },
    on: {
      "input": function($event) {
        _vm.indiceSelected = $event
      }
    }
  })], 1), _c('pred-line-chart', {
    attrs: {
      "legend": _vm.legend,
      "xAxis": _vm.chartXAxis,
      "series": _vm.chartSeries,
      "predseries": _vm.predChartSeries,
      "lineXAxis": _vm.lineXAxis,
      "areaXAxis": _vm.areaXAxis
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lineChartTip),
      expression: "lineChartTip"
    }],
    staticClass: "chart-tip"
  }, [_vm._v(_vm._s(_vm.lineChartTip))])], 1) : _vm._e(), (_vm.modalFormat === 'table') ? _c('div', {
    staticClass: "modal-bd-wrapper"
  }, [_c('div', {
    staticClass: "min-height-table"
  }, [_c('div', {
    staticClass: "modal-shadow"
  }), _c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.tabList), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.currentTab === item.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeViewTo(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  })), _c('div', {
    staticClass: "modal-table-wrapper"
  }, [(_vm.currentTab === 'kr') ? _c('KrAdviceTable', {
    attrs: {
      "hasCheckbox": false,
      "isEditable": _vm.curEditable,
      "list": _vm.krTableList,
      "extendColumns": _vm.extColumn
    },
    scopedSlots: {
      "delete": function(props) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.curEditable && props.item.status === 0),
            expression: "curEditable && props.item.status===0"
          }],
          staticClass: "fa fa-trash",
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteDetailItem($event, props.item)
            }
          }
        })]
      },
      "status": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.curEditable && props.item.status === 0),
            expression: "!curEditable && props.item.status===0"
          }]
        }, [_vm._v("已过期")])]
      }
    }
  }, [_c('template', {
    slot: "reasontype"
  }), _c('template', {
    slot: "reasontype"
  })], 2) : _vm._e(), (_vm.currentTab === 'service') ? _c('ServiceAdviceTable', {
    attrs: {
      "id": 'op-service-table',
      "hasCheckbox": false,
      "isEditable": _vm.curEditable,
      "list": _vm.serviceTableList,
      "extendColumns": _vm.extColumn
    },
    scopedSlots: {
      "delete": function(props) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.curEditable && props.item.status === 0),
            expression: "curEditable && props.item.status===0"
          }],
          staticClass: "fa fa-trash",
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteDetailItem($event, props.item)
            }
          }
        })]
      },
      "status": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.curEditable && props.item.status === 0),
            expression: "!curEditable && props.item.status===0"
          }]
        }, [_vm._v("已过期")])]
      }
    }
  }, [_c('template', {
    slot: "reasontype"
  }), _c('template', {
    slot: "reasontype"
  })], 2) : _vm._e(), (_vm.currentTab === 'accountBudget') ? _c('BudgetAdviceTable', {
    attrs: {
      "hasCheckbox": false,
      "isEditable": _vm.curEditable,
      "bgtype": _vm.currentTab === 'accountBudget' ? 'custname' : 'plan',
      "list": _vm.accountBudgetTableList,
      "extendColumns": _vm.extColumn
    },
    scopedSlots: {
      "delete": function(props) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.curEditable && props.item.status === 0),
            expression: "curEditable && props.item.status===0"
          }],
          staticClass: "fa fa-trash",
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteDetailItem($event, props.item)
            }
          }
        })]
      },
      "status": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.curEditable && props.item.status === 0),
            expression: "!curEditable && props.item.status===0"
          }]
        }, [_vm._v("已过期")])]
      }
    }
  }, [_c('template', {
    slot: "reasontype"
  }), _c('template', {
    slot: "reasontype"
  })], 2) : _vm._e(), (_vm.currentTab === 'planBudget') ? _c('BudgetAdviceTable', {
    attrs: {
      "hasCheckbox": false,
      "isEditable": _vm.curEditable,
      "bgtype": _vm.currentTab === 'accountBudget' ? 'custname' : 'plan',
      "list": _vm.planBudgetTableList,
      "extendColumns": _vm.extColumn
    },
    scopedSlots: {
      "delete": function(props) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.curEditable && props.item.status === 0),
            expression: "curEditable && props.item.status===0"
          }],
          staticClass: "fa fa-trash",
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteDetailItem($event, props.item)
            }
          }
        })]
      },
      "status": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.curEditable && props.item.status === 0),
            expression: "!curEditable && props.item.status===0"
          }]
        }, [_vm._v("已过期")])]
      }
    }
  }, [_c('template', {
    slot: "reasontype"
  }), _c('template', {
    slot: "reasontype"
  })], 2) : _vm._e(), (_vm.currentTab === 'price') ? _c('PriceAdviceTable', {
    attrs: {
      "hasCheckbox": false,
      "isEditable": _vm.curEditable,
      "list": _vm.priceTableList,
      "extendColumns": _vm.extColumn
    },
    scopedSlots: {
      "delete": function(props) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.curEditable && props.item.status === 0),
            expression: "curEditable && props.item.status===0"
          }],
          staticClass: "fa fa-trash",
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteDetailItem($event, props.item)
            }
          }
        })]
      },
      "status": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.curEditable && props.item.status === 0),
            expression: "!curEditable && props.item.status===0"
          }]
        }, [_vm._v("已过期")])]
      }
    }
  }, [_c('template', {
    slot: "reasontype"
  }), _c('template', {
    slot: "reasontype"
  })], 2) : _vm._e(), (_vm.currentTab === 'krPause') ? _c('PauseAdviceTable', {
    attrs: {
      "hasCheckbox": false,
      "isEditable": _vm.curEditable,
      "list": _vm.krPauseTableList,
      "extendColumns": _vm.extColumn
    },
    scopedSlots: {
      "delete": function(props) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.curEditable && props.item.status === 0),
            expression: "curEditable && props.item.status===0"
          }],
          staticClass: "fa fa-trash",
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteDetailItem($event, props.item)
            }
          }
        })]
      },
      "status": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.curEditable && props.item.status === 0),
            expression: "!curEditable && props.item.status===0"
          }]
        }, [_vm._v("已过期")])]
      }
    }
  }, [_c('template', {
    slot: "reasontype"
  }), _c('template', {
    slot: "reasontype"
  })], 2) : _vm._e()], 1), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.currentTemplateStatus === 0 || _vm.currentTemplateStatus === 4) && _vm.isSpecialUser === true && _vm.currentTemplateToday === true),
      expression: "(currentTemplateStatus===0 || currentTemplateStatus===4 ) && isSpecialUser===true && currentTemplateToday === true"
    }],
    staticClass: "note-text"
  }, [_vm._v("说明：下载模板可上传至点睛，只可下载关键词拓展、关键词优化模块，其他模块请手动操作      ")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.currentTemplateStatus === 0 || _vm.currentTemplateStatus === 2) && _vm.isSpecialUser === false),
      expression: "(currentTemplateStatus===0 || currentTemplateStatus===2) && isSpecialUser===false"
    }],
    staticClass: "btn-wrapper btn-absolute"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.canCurrentTemplateSync
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.syncToDianjing($event)
      }
    }
  }, [_vm._v("一键同步至点睛")]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveTemplate($event)
      }
    }
  }, [_vm._v("保存")])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.currentTemplateStatus === 0 || _vm.currentTemplateStatus === 4) && _vm.isSpecialUser === true && _vm.currentTemplateToday === true),
      expression: "(currentTemplateStatus===0 || currentTemplateStatus===4 ) && isSpecialUser===true && currentTemplateToday === true"
    }],
    staticClass: "btn-wrapper btn-absolute"
  }, [(_vm.currentTemplateStatus === 0) ? _c('DownloadBtn', {
    attrs: {
      "reportApi": _vm.downloadApi,
      "params": _vm.downloadParams,
      "pagetitle": "优化建议操作列表",
      "btnTitle": "下载模板"
    }
  }) : _vm._e(), (_vm.currentTemplateStatus === 4) ? _c('DownloadBtn', {
    attrs: {
      "reportApi": _vm.downloadApi,
      "params": _vm.downloadParams,
      "pagetitle": "优化建议操作列表",
      "btnTitle": "再次下载"
    }
  }) : _vm._e(), (_vm.currentTemplateStatus === 0) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveTemplate($event)
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _c('div', {
    staticClass: "sync-alert-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-times close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeSyncAlert()
      }
    }
  }), (_vm.alertStatus === 1) ? _c('div', {
    staticClass: "diff-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h"
  }), _c('span', [_vm._v("正在同步至点睛用户")])]), _c('p', {
    staticClass: "alert-content"
  }, [_vm._v("请耐心等待...")])]) : _vm._e(), (_vm.alertStatus === 2) ? _c('div', {
    staticClass: "diff-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _c('span', [_vm._v("同步完成")])]), _c('p', {
    staticClass: "alert-content"
  }, [_vm._v(_vm._s(_vm.alertContentTotal))]), _c('p', {
    staticClass: "btn-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeSyncAlert()
      }
    }
  }, [_vm._v("确定")])])]) : _vm._e(), (_vm.alertStatus === 3) ? _c('div', {
    staticClass: "diff-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _c('span', [_vm._v("同步未全部完成")])]), _c('p', {
    staticClass: "alert-content alert-top"
  }, [_vm._v(_vm._s(_vm.alertContentParticial))]), _c('p', {
    staticClass: "alert-content"
  }, [_vm._v("若继续同步失败，建议您稍候重试或联系客服人员 ")]), _c('p', {
    staticClass: "btn-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.syncToDianjing($event)
      }
    }
  }, [_vm._v("继续同步")]), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeSyncAlert()
      }
    }
  }, [_vm._v("取消")])])]) : _vm._e(), _c('i', {
    staticClass: "alert-wrapper-arrow"
  })])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "9"
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73a59e38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73a59e38!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/operatelist.vue
// module id = 771
// module chunks = 0